import { useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/UI/Button';

const RejectOfferScreen = ({
  literals,
  isSubmitting = false,
  blockedMessage = '',
  onConfirm,
  onBack,
}) => {
  const [reason, setReason] = useState('');
  const [detail, setDetail] = useState('');
  const reasons = literals.reasons || [];
  const otherSelected = reason === 'OTHER';
  const canConfirm = Boolean(reason)
    && (!otherSelected || detail.trim())
    && !isSubmitting;

  return (
    <div className='full-screen-container digital-loan-preoffer'>
      <div className='screen-content digital-loan-preoffer__scroll'>
        <h1 className='digital-loan-phase2__title'>{literals.title}</h1>
        <p className='digital-loan-phase2__body mb-4'>{literals.body}</p>
        {reasons.map((item) => (
          <label className='d-flex align-items-center gap-2 mb-3' key={item.id}>
            <input
              type='radio'
              name='reject-offer-reason'
              value={item.id}
              checked={reason === item.id}
              onChange={() => setReason(item.id)}
            />
            <span>{item.label}</span>
          </label>
        ))}
        {otherSelected && (
          <input
            className='form-control mb-3'
            name='rejectDetail'
            placeholder={literals.detailPlaceholder}
            value={detail}
            onChange={(event) => setDetail(event.target.value)}
          />
        )}
        {blockedMessage && (
          <p className='digital-loan-phase2__body' role='alert'>
            {blockedMessage}
          </p>
        )}
      </div>
      <div className='screen-actions'>
        <Button
          text={literals.confirm}
          disabled={!canConfirm}
          loading={isSubmitting}
          onClick={() => onConfirm({ reason, detail })}
        />
        <Button text={literals.back} type='secondary' onClick={onBack} />
      </div>
    </div>
  );
};

RejectOfferScreen.propTypes = {
  literals: PropTypes.object.isRequired,
  isSubmitting: PropTypes.bool,
  blockedMessage: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default RejectOfferScreen;
